"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AnalyticsProvider = void 0;

var tslib_1 = require("tslib");

var react_1 = tslib_1.__importDefault(require("react"));

var AnalyticsContext_1 = require("./AnalyticsContext");

var AnalyticsProvider = function AnalyticsProvider(_a) {
  var children = _a.children,
      client = _a.client;
  return react_1.default.createElement(AnalyticsContext_1.AnalyticsContext.Provider, {
    value: client
  }, children);
};

exports.AnalyticsProvider = AnalyticsProvider;